import { barbadosConfigs } from '@/constants/tenant-configs/barbados';
import { caymanConfigs } from '@/constants/tenant-configs/cayman';

import { Tenant } from '@/types/common';

type GDPRContentConfig = {
  privacyPolicyURL: string;
};

export const getGDPRConfig = (tenant: Tenant): GDPRContentConfig => {
  return {
    privacyPolicyURL: getPrivacyURL(tenant),
  };
};

const getPrivacyURL = (tenant: Tenant): string => {
  switch (tenant) {
    case Tenant.Cayman:
      return caymanConfigs.links.privacyPolicyURL;
    case Tenant.Barbados:
      return barbadosConfigs.links.privacyPolicyURL;
    default:
      return 'https://default.com/privacy';
  }
};
